import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  title: {
    fontWeight: 600,
  },
  actions: {
    padding: '8px 16px 16px',
  },
}));

export default useStyles;
